// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
    getAuth,
    connectAuthEmulator,
    setPersistence,
    browserLocalPersistence
} from "firebase/auth";
import {
    initializeAppCheck,
    ReCaptchaV3Provider,
    getToken
} from "firebase/app-check";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getDatabase, connectDatabaseEmulator } from "firebase/database";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getMessaging, onMessage } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";
import { getPerformance } from "firebase/performance";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// import { Loader } from "@googlemaps/js-api-loader";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig1 = {
    apiKey: "AIzaSyCq_AYmrbkB4VromUVhAnqXkuY7iAQD9Fs",
    authDomain: "me-heartbank.firebaseapp.com",
    projectId: "me-heartbank",
    databaseURL: "https://me-heartbank-default-rtdb.firebaseio.com",
    storageBucket: "me-heartbank.firebasestorage.app",
    messagingSenderId: "591045513975",
    appId: "1:591045513975:web:499f8abf6df451e596b9f2",
    measurementId: "G-ZX72NBZLPT"
};

const firebaseConfig2 = {
    apiKey: "AIzaSyDPRrfmOI1mL7lQOpjO68lViV1X2WRjAIY",
    authDomain: "siliconwat.firebaseapp.com",
    projectId: "siliconwat",
    databaseURL: "https://siliconwat.firebaseio.com",
    storageBucket: "siliconwat.appspot.com",
    messagingSenderId: "140538393451",
    appId: "1:140538393451:web:9c142134efdc0ecba4122e",
    measurementId: "G-1PQ2MKK8GM"
};

// let heartbank: FirebaseApp, siliconwat: FirebaseApp;

// switch (getApps().length) {
//     case 2:
//         siliconwat = getApps()[0]; // TODO: check if this is always config1
//         heartbank = getApps()[1];
//         break;
//     case 1:
//         siliconwat = getApps()[0];
//         heartbank = initializeApp(firebaseConfig2, "siliconwat");
//         break;
//     default:
//         siliconwat = initializeApp(firebaseConfig1);
//         heartbank = initializeApp(firebaseConfig2, "siliconwat");
// }

//console.log("Project 1 App:", heartbank.name); // Should log: [DEFAULT]
//console.log("Project 2 App:", siliconwat.name); // Should log: secondary

const app = initializeApp(firebaseConfig2);
const heartbank = initializeApp(firebaseConfig1, "HeartBank");

// Extend the Window interface to include custom properties
declare global {
    interface Window {
        FIREBASE_APPCHECK_DEBUG_TOKEN?: boolean;
        // loader?: Loader;
        // initMap?: () => void;
    }
}
// window.FIREBASE_APPCHECK_DEBUG_TOKEN = true; // 66ce3998-a16b-4051-ac4e-9512b6efa166

// Pass your reCAPTCHA v3 site key (public key) to activate(). Make sure this
// key is the counterpart to the secret key you set in the Firebase console.

// temp
// export const appCheck = initializeAppCheck(app, {
//     provider: new ReCaptchaV3Provider(
//         "6LeJwx8rAAAAALGyGJ2HUPe1fJ-BZ9DolAw5yZBW"
//     ),
//     // Optional argument. If true, the SDK automatically refreshes App Check
//     // tokens as needed.
//     isTokenAutoRefreshEnabled: true
// });

//getToken(appCheck).then(({ token }) => console.log(token));

// Firebase APIs
export const authB = getAuth(heartbank);
export const fsB = getFirestore(heartbank);

export const auth = getAuth(app);
export const fs = getFirestore(app);
export const db = getDatabase(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const messaging = getMessaging(app);
export const analytics = getAnalytics(app);
export const performance = getPerformance(app);

//setPersistence(hb, browserLocalPersistence);
//setPersistence(auth, browserLocalPersistence);

if (process.env.NODE_ENV !== "production") {
    connectAuthEmulator(authB, "http://localhost:9099", {
        disableWarnings: true
    });
    connectAuthEmulator(auth, "http://localhost:9093", {
        disableWarnings: true // false
    });

    connectFirestoreEmulator(fsB, "localhost", 8081);
    connectFirestoreEmulator(fs, "localhost", 8083);

    connectDatabaseEmulator(db, "localhost", 9006);
    connectStorageEmulator(storage, "localhost", 9193);
    connectFunctionsEmulator(functions, "localhost", 5004);
}

onMessage(messaging, (payload) => {
    //console.log("Message received in foreground: ", payload);
    // if (isDesktop) // Browsers won't show a banner, so you have to trigger one manually:
    new Notification(payload.data?.title || "New Reader!", {
        body: payload.data?.body || "Earth",
        icon:
            payload.data?.image ||
            payload.data?.icon ||
            "https://raw.githubusercontent.com/siliconwat/bedok.siliconwat.dev/main/siliconwat.png"
    });
});
